export const getIsSidebarMaxHeight = (sidebarEl: React.MutableRefObject<HTMLElement | null>) => {
	if (!sidebarEl.current) return false;
	const rect = sidebarEl.current.getBoundingClientRect();
	const availableHeight = window.innerHeight - 300;

	return rect.height > availableHeight;
};
